import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import Translation from "../../../translation/translation";

function LightboxCustomerReviews(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.CUSTOMER_REVIEWS_VIEW];

    return (
        <LightboxView
            viewName={FilterSections.CUSTOMER_REVIEWS_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <div className="lightbox-filter-section__headline">
                    <Translation translationKey="catalog-filter-group-reviews" />
                </div>
                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP}
                    value={props.customerReviewDryTractionRatingAvgGroupValue}
                    options={props.customerReviewDryTractionRatingAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />

                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP}
                    value={props.customerReviewLowNoiseRatingAvgGroupValue}
                    options={props.customerReviewLowNoiseRatingAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP}
                    value={props.customerReviewRideComfortRatingAvgGroupValue}
                    options={props.customerReviewRideComfortRatingAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP}
                    value={props.customerReviewSteeringResponseAvgGroupValue}
                    options={props.customerReviewSteeringResponseAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP}
                    value={props.customerReviewTreadWearAvgGroupValue}
                    options={props.customerReviewTreadWearAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP}
                    value={props.customerReviewValueForMoneyAvgGroupValue}
                    options={props.customerReviewValueForMoneyAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP}
                    value={props.customerReviewWetTractionRatingAvgGroupValue}
                    options={props.customerReviewWetTractionRatingAvgGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />

            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxCustomerReviews.propTypes = {
    customerReviewDryTractionRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewDryTractionRatingAvgGroupOptions: PropTypes.array.isRequired,

    customerReviewLowNoiseRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewLowNoiseRatingAvgGroupOptions: PropTypes.array.isRequired,

    customerReviewRideComfortRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewRideComfortRatingAvgGroupOptions: PropTypes.array.isRequired,

    customerReviewSteeringResponseAvgGroupValue: PropTypes.string.isRequired,
    customerReviewSteeringResponseAvgGroupOptions: PropTypes.array.isRequired,

    customerReviewTreadWearAvgGroupValue: PropTypes.string.isRequired,
    customerReviewTreadWearAvgGroupOptions: PropTypes.array.isRequired,

    customerReviewValueForMoneyAvgGroupValue: PropTypes.string.isRequired,
    customerReviewValueForMoneyAvgGroupOptions: PropTypes.array.isRequired,

    customerReviewWetTractionRatingAvgGroupValue: PropTypes.string.isRequired,
    customerReviewWetTractionRatingAvgGroupOptions: PropTypes.array.isRequired,

    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxCustomerReviews };
